import { render, staticRenderFns } from "./SettsHelp.vue?vue&type=template&id=4fb50d1a"
import script from "./SettsHelp.vue?vue&type=script&lang=js"
export * from "./SettsHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports